import { memo } from "react";

import { useRequiredContext } from "@redotech/react-util/context";
import CursorClickIcon from "@redotech/redo-icons/cursor-click-01.svg";
import CursorClickIconFilled from "@redotech/redo-icons/cursor-click-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";

export const RecoverItems = memo(function RecoverItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.recoverHref }}
      FilledIcon={CursorClickIconFilled}
      friendlyName="Recover"
      id="recover"
      UnfilledIcon={CursorClickIcon}
    />
  );
});
